import { useAppSelector } from 'app/providers/StoreProvider/config/store';
import React, { FC, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import IconArrow from 'shared/assets/svg/icon-arrow.svg';
import ModuleLoader, {
  ReducesList,
} from 'shared/lib/ModuleLoader/ModuleLoader';
import { setAllVisible } from 'shared/lib/helpers';
import { Button, ORDSection } from 'shared/ui';
import Carousel from 'shared/ui/Carousel';
import blogSlice from '../../model/blogSlice';
import './BlogDetailPage.less';

const initialReducers: ReducesList = {
  blog: blogSlice.reducer,
};

const BlogDetailPage: FC = () => {
  const { article } = useParams();
  const data = useAppSelector(
    (selector) => selector.blog?.articles[article as string],
  );
  const articleList = useAppSelector((selector) => selector.blog?.articles);
  useEffect(() => {
    setAllVisible();
  }, []);
  return (
    <ModuleLoader reducers={initialReducers} removeAfterUnmount>
      <ORDSection
        isH1={false}
        className="blog-detail"
        id="blog-detail"
        description={
          <div className="content">
            {data && (
              <>
                <img
                  src={data?.image}
                  alt={data?.title}
                  title={data?.title}
                  className="image"
                />
                <h1 className="title">{data?.title}</h1>
                {data.content.map((item) => (
                  <div className="content">
                    {item.subTitle && (
                      <h2 className="sub-title">{item.subTitle}</h2>
                    )}
                    {item.text.map((text) => (
                      <p className="text">{text}</p>
                    ))}
                  </div>
                ))}
              </>
            )}
            <div className="others">
              <span>Другие статьи</span>
              <Link to="/blog">
                <Button theme="link" suffixIcon={<IconArrow />}>
                  Все статьи
                </Button>
              </Link>
            </div>
            {articleList && (
              <Carousel
                items={Object.entries(articleList)
                  .filter(([key]) => key !== article)
                  .map(([key, value]) => ({
                    image: value.image,
                    title: value.title,
                    link: `/blog/${key}`,
                  }))}
              />
            )}
          </div>
        }
      />
    </ModuleLoader>
  );
};

export default BlogDetailPage;
